import { createReducer } from "utilities";
import * as TYPES from "./constants";
import { normalize, getPagination } from "utilities";

const initialState = {
  results: normalize(),
  pagination: getPagination({}),
  fetching: false,
  error: null,
};
const reducer = createReducer(initialState, {
  [TYPES.REQUEST](state) {
    return {
      ...state,
      fetching: true,
    };
  },
  [TYPES.FAILURE](state, action) {
    return {
      ...state,
      fetching: false,
      error: action.error,
    };
  },
  [TYPES.SUCCESS](state, { staff }) {
    return {
      ...state,
      fetching: false,
      error: null,
      results: normalize(staff.results),
      pagination: getPagination(staff),
    };
  },
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/staff/reducer.js